var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenuGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 10.5857L16.9507 5.63574L18.3647 7.04974L13.4147 11.9997L18.3647 16.9497L16.9507 18.3637L12.0007 13.4137L7.05072 18.3637L5.63672 16.9497L10.5867 11.9997L5.63672 7.04974L7.05072 5.63574L12.0007 10.5857Z",
    fill: "#080917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuGrey);
export default __webpack_public_path__ + "static/media/close-menu-grey.d845f1875a28c35f967714cdbd261a97.svg";
export { ForwardRef as ReactComponent };